var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49979 0.894531C4.30572 0.894531 0.894531 4.30572 0.894531 8.49979C0.894531 12.6939 4.30572 16.1051 8.49979 16.1051C12.6939 16.1051 16.1051 12.6939 16.1051 8.49979C16.1051 4.30572 12.6939 0.894531 8.49979 0.894531Z",
    fill: "#E1F4D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.81382 0 0 3.81382 0 8.5C0 13.1862 3.81382 17 8.5 17C13.1862 17 17 13.1862 17 8.5C17 3.81382 13.1862 0 8.5 0ZM8.5 16.1053C4.30592 16.1053 0.894737 12.6941 0.894737 8.5C0.894737 4.30592 4.30592 0.894737 8.5 0.894737C12.6941 0.894737 16.1053 4.30592 16.1053 8.5C16.1053 12.6941 12.6941 16.1053 8.5 16.1053Z",
    fill: "#1C452B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 7.09939C8.75677 7.09939 8.96684 7.32051 8.96684 7.59077V11.2762C8.96684 11.5465 8.75677 11.7676 8.50002 11.7676C8.24327 11.7676 8.0332 11.5465 8.0332 11.2762V7.59077C8.0332 7.32051 8.24327 7.09939 8.50002 7.09939Z",
    fill: "#1C452B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 5.23213C8.75784 5.23213 8.96684 5.44114 8.96684 5.69895C8.96684 5.95677 8.75784 6.16577 8.50002 6.16577C8.24221 6.16577 8.0332 5.95677 8.0332 5.69895C8.0332 5.44114 8.24221 5.23213 8.50002 5.23213Z",
    fill: "#1C452B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.f32bd903727b0445fcdb11c54a1fde19.svg";
export { ForwardRef as ReactComponent };